<template>
  <div class="test">
    <h1>Тест</h1>
    <b-card>
      <b-overlay
        :show="isLoading"
        spinner-variant="primary"
        variant="white"
        rounded="lg"
      >
        <h4><b-icon-text-left /> Основне</h4>
        <label for=""> <strong>Назва</strong> </label>
        <b-form-input v-model="test.name" placeholder="Назва тесту">
        </b-form-input>
        <div class="pt-4">
          <label for=""> <strong> Опис </strong></label>
          <b-form-textarea
            rows="4"
            placeholder="Короткий опис"
            v-model="test.description"
          ></b-form-textarea>
          <text-length :text="test.description" :maxLength="220" />
        </div>
        <div class="pt-4">
          <label for=""> <strong>Тип тесту</strong> </label>
          <v-select
            :options="testTypes"
            placeholder="Оберіть тип"
            :reduce="(option) => option.value"
            :disabled="!isCreating"
            v-model="test.type"
          />
        </div>
      </b-overlay>
    </b-card>
    <b-card class="mt-4" dessription="">
      <b-overlay
        :show="isLoading"
        spinner-variant="primary"
        variant="white"
        rounded="lg"
      >
        <div
          class="results__header d-flex align-items-center justify-content-between"
        >
          <h4><b-icon-bar-chart-fill /> Результати</h4>
          <b-button
            size="sm"
            variant="link"
            @click="resultsClosed = !resultsClosed"
          >
            <span v-if="!resultsClosed"> <b-icon-chevron-up /></span>
            <span v-else>
              <b-icon-chevron-down />
            </span>
          </b-button>
        </div>

        <p class="mb-3"></p>
        <template v-if="test.type != 'psycho'">
          <b-alert show variant="info mt-2 py-1 px-2">
            Максимально балів за тест:
            <strong>{{ max_points }}</strong> (обчислено на основі запитань)
          </b-alert>
          <div class="results__collapse" :class="{ closed: resultsClosed }">
            <resultGrades :gradesInput="test.grades" ref="grades" />
          </div>
        </template>
        <template v-if="test.type == 'psycho'">
          <psychoResults :descriptorsInput="descriptors" />
        </template>
      </b-overlay>
    </b-card>
    <b-card class="mt-4" v-show="test.type">
      <h4><b-icon-question /> Запитання тесту</h4>
      <b-overlay :show="isLoading" spinner-variant="primary" rounded="lg">
        <template v-if="test.type == 'basic'">
          <basicTest ref="basic" :questionsInput="test.questions" />
        </template>

        <template v-if="test.type == 'logic'">
          <logicTest ref="logic" :questionsInput="test.questions" />
        </template>
        <template v-if="test.type == 'psycho'">
          <psychoTest
            ref="psycho"
            :questionsInput="test.questions"
            :descriptorsInput="descriptors"
          />
        </template>
      </b-overlay>
    </b-card>

    <div class="mt-4 mb-4">
      <div class="d-flex w-100 justify-content-between">
        <b-button @click="showRemovalModal = true" variant="outline-danger">
          Видалити тест
        </b-button>
        <b-button
          @click="saveAction"
          size="lg"
          variant="primary"
          :disabled="isLoading"
        >
          Зберегти зміни
        </b-button>
      </div>
    </div>
    <b-modal v-model="showRemovalModal" hide-footer hide-header centered>
      <b-overlay :show="isLoading" spinner-variant="primary" rounded="lg">
        <h3>Видалити тест?</h3>
        <b-alert show variant="danger">
          Увага! Цю дію неможливо буде скасувати
        </b-alert>
        <div class="controls pt-3">
          <b-button
            @click="removeTest"
            variant="danger"
            class="w-100 block mb-3"
          >
            Видалити
          </b-button>
          <b-button variant="outline-primary" class="w-100 block">
            Скасувати
          </b-button>
        </div>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import basicTest from "./test-types/basic-test.vue";
import psychoTest from "./test-types/psycho-test.vue";
import logicTest from "./test-types/logic-test.vue";
import resultGrades from "./test-single-results.vue";
import psychoResults from "./test-psycho-results.vue";
export default {
  components: {
    basicTest,
    psychoTest,
    logicTest,
    resultGrades,
    psychoResults,
  },
  data() {
    return {
      isLoading: false,
      isCreating: false,
      showRemovalModal: false,
      resultsClosed: true,

      //test object
      questions: [],
      descriptors: [
        {
          name: "Лідерство",
          id: "leadership",
          description:
            "ми визначаємо в даному дескрипторі, чи дійсно володіє лідерськими якостями кандидат на посаду, що є важливою інформацією для процесу відбору на керівні посади в управлінні. «Полюсний розподіл типу» у відборі дає нам можливість побачити в однозначному розрізі, готовність людини до виконання лідерських компетенцій або ще потрібно розвивати цей компонент в якості зони зросту. Де Тип 1 буде позначати сильну лідерську позицію, компетенцію та готовність для виконання даної ролі, а Тип 2 буде позначати дану компетенцію в якості зони зросту",
          types: ["1", "2"],
        },
        {
          name: "Мислення",
          id: "thinking",
          description:
            "важливий дескриптор за типом, який має визначити, структура мислення, за домінацією правої чи лівої півкулі головного мозку, схильність до гуманітарного чи технічного типу діяльності, прийняття рішень у стресових ситуаціях тощо. Де крайніми «полюсами» виступатимуть позначки «Л» та «П»",
          types: ["Л", "П"],
        },
        {
          name: "Акцентуаційно-поведінковий тип",
          id: "behaviour",
          description:
            "ми маємо визначити за цим дескриптором зовнішній прояв поведінки кандидата, схильність до конфліктності (конфліктогенність), комунікаційний спосіб прояву, тип акцентуації, елементи позначення «А» та «Н»",
          types: ["А", "Н"],
        },
        {
          name: "Темпераментально-емоційний тип",
          id: "temperament",
          description:
            "триманий результат дозволить нам визначити загальну темпераментальну характеристику, емоційну підготовленість та особливості кандидата, що є важливими при урахуванні його подальшої роботи та комунікації із потенційним роботодавцем. «Е» та «І».",
          types: ["Е", "І"],
        },
      ],
      test: {
        name: "",
        description: "",
        type: "basic",
        questions: [],
      },
    };
  },
  computed: {
    testTypes() {
      let types = [
        {
          value: "basic",
          label: "Законодавча група",
        },
        {
          value: "psycho",
          label: "Психологічна група",
        },
        {
          value: "logic",
          label: "Логічно-вербальна група",
        },
      ];

      return types;
    },
    test_questions() {
      let type = this.test.type;
      // let questions = [];
      // if (type && this.$refs[type]) {
      //   questions = this.$refs[type].questions;
      // }
      return this.$refs[type] ? this.$refs[type].questions : [];
    },
    max_points() {
      let points = 0;
      let questions = this.test_questions;
      if (questions.length) {
        questions.forEach((el) => {
          if (el.points) {
            points += Number(el.points);
          } else {
            points++;
          }
        });
      }

      return points;
    },
  },

  methods: {
    async fetchTest() {
      this.isLoading = true;

      let args = {
        collectionName: "tests",
        where: ["id", "==", Number(this.$route.params.id)],
        limit: 1,
      };
      try {
        let result = await this.$db.getCollection(args);
        this.test = result.docs[0];
        setTimeout(() => {
          this.isLoading = false;
        }, 600);
      } catch {
        this.$toast.error("Щось пішло не так");
        this.isLoading = false;
      }
    },
    async getNewId() {
      let result = await this.$api
        .get("/get/counter/?type=tests")
        .then((data) => {
          return data;
        })
        .catch((error) => {
          return error;
        });

      return result.data.count;
    },
    saveAction() {
      if (this.isCreating) {
        this.createTest();
      } else {
        this.saveTest();
      }
    },
    async createTest() {
      this.isLoading = true;
      let test = this.test;
      if (test.type == "psycho") {
        test["descriptors"] = this.descriptors;
      } else {
        test["grades"] = this.$refs.grades.grades;
      }
      let type = this.test.type;
      test["questions"] = this.$refs[type].questions;
      if (!test.questions) {
        test["questions"] = [];
      }
      if (this.isCreating) {
        test["id"] = await this.getNewId();
      }
      console.log(test);
      await this.$db.add("tests", test);
      this.$router.push({ name: "test-single", params: { id: test.id } });
      this.fetchTest();
      this.isLoading = false;
    },
    async saveTest() {
      this.isLoading = true;
      let type = this.test.type;
      if (this.test.type == "psycho") {
        this.test.descriptors = this.descriptors;
      } else {
        this.test["grades"] = this.$refs.grades.grades;
      }

      this.test["questions"] = this.$refs[type].questions;
      let test = this.test;
      await this.$db.update("tests", test.uid, test);
      this.$toast.success("Тест успішно збережено");
      this.isLoading = false;
    },
    async removeTest() {
      this.isLoading = true;
      let test = this.test;
      await this.$db.delete("tests", test.uid);
      this.$router.push({ name: "admin-tests" });
      this.$toast.warning("Тест видалено");
      this.isLoading = false;
    },
  },
  mounted() {
    if (this.$route.params.id == "new") {
      this.isCreating = true;
    } else {
      this.fetchTest();
    }
  },
};
</script>

<style lang="scss" scoped>
.test {
  &__question-item {
    margin-bottom: 30px;
  }
  .results__collapse {
    max-height: 4000px;

    transition: max-height 0.3s ease-out !important;
    &.closed {
      overflow: hidden;
      max-height: 0px;
      transition: max-height 0.3s ease-out !important;
    }
  }
}
</style>
